/** @format */

import { ColumnsType } from "antd/lib/table";

const brandListColumns: ColumnsType<object> = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
];

export default brandListColumns;
